import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '../_service/authentication.service';
import {inject} from '@angular/core';
import {BusinessService} from '../_service/business.service';
import {catchError, firstValueFrom, map, of} from 'rxjs';
import {LoginResponseModel} from '../models/LoginResponse.model';

export const isLoggedIn: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);
  const businessService = inject(BusinessService);
  const router = inject(Router);
  console.log('inside activate ' + authenticationService.isAuth());
  // check if the user was already logged in
  console.log('inside activate checking logged in? ' + localStorage.getItem('token') + ': ' + authenticationService.isAuth());
  if(localStorage.getItem('token') && !authenticationService.isAuth()){
    return firstValueFrom(authenticationService.checkValidSession().pipe(map(async (loginResponse: LoginResponseModel) : Promise<boolean> => {
        console.log('valid session checked?');
        console.log('checking session');
        if (loginResponse !== null && loginResponse.error !== null) {
          await businessService.loadBusiness().then();
          authenticationService.authenticatedSuccessfully(loginResponse, false);
          return true;
        } else {
          localStorage.removeItem('token');
          router.navigate(['/']);
          return false;
        }
      }),
      catchError(() => {
        router.navigate(['/']);
        return of(false);
      }))).then();
  } else if( authenticationService.isAuth()) {
    return true;
  } else {
    router.navigate(['/']);
    return false;
  }
}


export function roleGuard(
  requiredRole: string
): CanActivateFn {
  return () => {
    const businessService = inject(BusinessService);
    const router = inject(Router);
    if(businessService.getLoginResponse() && businessService.getLoginResponse().securityRoles){
      return businessService.getLoginResponse().securityRoles.has(requiredRole);
    }
    return false;
  };
}
